    <template>
   <section v-maximizable>
     <div class="table-tab admin__table-tab" >
       <div class="table-tab__actions-block">
         <table class="table-tab__block table">
           <thead class="table-tab__thead">
           <tr class="table-tab__row-auto-height">
             <th>{{$t('labels.actions')}}</th>
           </tr>
           </thead>
           <tbody class="table-tab__tbody">
           <template  v-for="(item, rowId) in items">
             <tr class="table-tab__row-auto-height table-tab__tr table-tab__tr-border">
               <template v-if="item.editable">
                 <th class="table-tab__actions table-tab__actions--redaction u-align-items-start">
                   <div class="table-tab__actions">
                     <button :title="$t('buttons.save')" @click.prevent="onSaveClick" :disabled="$v.items && $v.items[rowId].$error">
                       <img class="table-tab__img-4" src="@/assets/img/static/tab-ok.svg" alt="">
                     </button>
                     <button :title="$t('buttons.cancel')" @click.prevent="onCancelClick">
                       <img class="table-tab__img-5" src="@/assets/img/static/tab-close.svg" alt="">
                     </button>
                   </div>
                 </th>
               </template>
               <template v-else>
                 <th class="table-tab__actions">
                   <div class="table-tab__actions">
                     <button :title="$t('buttons.edit')" @click.prevent="onEditClick(rowId)" :disabled="editableItem !== undefined" v-if="!item.readonly">
                       <img class="table-tab__img-1" src="@/assets/img/static/b-icon_edit.svg" alt="">
                     </button>
                     <button :title="$t('buttons.copy')" @click.prevent="onCopyClick" :disabled="editableItem !== undefined" v-if="!item.readonly">
                       <img class="table-tab__img-2" src="@/assets/img/static/b-icon_add-compare.svg" alt="">
                     </button>
                     <button :title="$t('buttons.delete')" @click.prevent="onRemoveClick(rowId)" :disabled="editableItem !== undefined" v-if="!item.readonly">
                       <img class="table-tab__img-3" src="@/assets/img/static/trashcan.svg" alt="">
                     </button>
                   </div>
                 </th>
               </template>
             </tr>
           </template>
           </tbody>
         </table>
       </div>
       <div class="table-tab__container"
            style="overflow: hidden; overflow-x: auto; outline: none; width: calc(100% - 180px)">
         <table class="table-tab__block table " style="min-width: 1500px">
           <thead class="table-tab__thead">
           <tr class="table-tab__row-auto-height">
             <th class="table-tab__width-90 table-tab__th--row">№</th>
             <th>{{$t('form.tender.reduction.criterion')}}</th>
             <th>{{$t('form.tender.reduction.estimation-unit')}}</th>
             <th>{{$t('form.tender.reduction.format')}}</th>
             <th>{{$t('form.tender.reduction.value-name')}}</th>
             <th>{{$t('form.tender.reduction.value')}}</th>
             <th>{{$t('form.tender.reduction.unit')}}</th>
           </tr>
           </thead>
           <tbody class="table-tab__tbody">
             <template v-for="(item, itemId) in items">
               <tr class="table-tab__tr-border table-tab__row-auto-height">
                 <!-- Открытие таба table-tab__btn-open-->
                 <th class="table-tab__th table-tab__th--row table-tab__btn-open">
                   <img src="@/assets/img/static/arrow-up.png" alt="">
                   {{itemId + 1}}
                 </th>

                 <td v-if="item.editable">
                   <div class="a-form-field" style="width: 180px">
                     <!--class="a-input-group table-tab__input-max-width-140"-->
                     <dropdown-new :options="availableCriteria" v-model="item.id"></dropdown-new>
                   </div>
                 </td>
                 <td v-else>{{item.criterionName}}</td>

                 <td v-if="item.editable">
                   <div class="a-form-field" style="width: 180px">
                     <!--class="a-input-group table-tab__input-max-width-140"-->
                     <dropdown-new :value="item.unit" @input="item.unit = new enums.AssessmentUnit($event)">
                       <option value :label="'assessment-unit.empty'"></option>
                       <option :value="enums.AssessmentUnit.LOT" :label="'assessment-unit.lot'"></option>
                       <option :value="enums.AssessmentUnit.CATALOG" :label="'assessment-unit.catalog'"></option>
                     </dropdown-new>
                   </div>
                 </td>
                 <td v-else>{{$t(item.unit.label)}}</td>

                 <td v-if="item.editable">
                   <div class="a-form-field" style="width: 180px">
                     <!--class="a-input-group table-tab__input-max-width-140"-->
                     <dropdown-new :value="item.format" @input="item.format = new enums.ProposalFormat($event)">
                       <option value :label="'proposal-format.empty'"></option>
                       <option :value="enums.ProposalFormat.NUMBER" :label="'proposal-format.number'"></option>
                       <option :value="enums.ProposalFormat.CHOICE" :label="'proposal-format.choice'"></option>
                     </dropdown-new>
                   </div>
                 </td>
                 <td v-else>{{$t(item.format.label)}}</td>

                 <template v-if="item.format == enums.ProposalFormat.NUMBER">
                   <td>
                     <p>{{$t('form.tender.reduction.min-value')}}</p>
                     <p>{{$t('form.tender.reduction.max-value')}}</p>
                   </td>
                   <td v-if="item.editable">
                     <input-cost class="a-input" v-model="item.minValue"></input-cost><br>
                     <input-cost class="a-input" v-model="item.maxValue"></input-cost>
                   </td>
                   <td v-else>
                     <p>{{item.minValue | price}}</p>
                     <p>{{item.maxValue | price}}</p>
                   </td>
                 </template>
                 <template v-else-if="item.format == enums.ProposalFormat.CHOICE">
                   <td v-if="item.editable" style="vertical-align: top!important;">
                     <div class="a-form-field" v-for="(value, valId) in item.values">
                       <!--class="a-input-group table-tab__input-max-width-140"-->
                       <input class="a-input" type="text" v-model="item.values[valId].name"/><br>
                     </div>
                     <div class="table-tab__btn-end table-tab__add">
                       <button class="u-font-size-14 " @click.prevent="onAddValuesClick(items[itemId])">
                         <img src="@/assets/img/static/b-icon_plus-str.svg" alt="">
                         {{$t('form.tender.reduction.add-value')}}
                       </button>
                     </div>
                   </td>
                   <td v-else>
                     <p v-for="item in item.values">{{item.name}}</p>
                   </td>

                   <td v-if="item.editable" style="vertical-align: top!important;">
                     <div class="table-tab__input-remove" v-for="(value, valId) in item.values">
                       <div class="a-form-field">
                         <!--class="a-input-group table-tab__input-max-width-140"-->
                         <input-cost class="a-input" v-model="item.values[valId].value"></input-cost><br>
                       </div>
                       <button @click.prevent="item.values.splice(valId, 1)">
                         <img src="@/assets/img/static/trashcan.svg" alt="">
                       </button>
                     </div>
                   </td>
                   <td v-else>
                     <p v-for="item in item.values">{{item.value | price}}</p>
                   </td>
                 </template>
                 <template v-else>
                   <td></td>
                   <td></td>
                 </template>


                 <td v-if="item.editable">
                   <div class="a-form-field" style="width: 180px">
                     <!--class="a-input-group table-tab__input-max-width-140"-->
                     <input class="a-input" v-model="item.okei"/>
                   </div>
                 </td>
                 <td v-else>
                   {{item.type == 'PriceLot' ? $t('form.tender.reduction.lot-currency') : item.okei}}
                 </td>
               </tr>
             </template>
           </tbody>
         </table>
       </div>

       <div class="table-tab__btn-end">
         <button @click.prevent="onAddCriterionClick" :disabled="editableItem !== undefined">
           <img src="@/assets/img/static/b-icon_plus-str.svg" alt="">
           {{$t('buttons.add-price-criteria')}}
         </button>
       </div>
     </div>
   </section>
</template>

<script>
  import $ from 'jquery'
  import { required, requiredIf } from '@/validators'

  export default {
    props: {
      value: {
        type: Object,
        required: true
      },

      criteria: {
        type: Array
      }
    },

    data: () => ({
      editableItem: undefined,
      items: undefined
    }),

    validations() {
      if (this.editableItem === undefined) return {};

      return {
        items: {
          [this.editableItem]: {
            id: {
              required
            },
            unit: {
              required
            },
            format: {
              required
            },
            okei: {
              required: requiredIf(function(item) { item.format == this.enums.ProposalFormat.CHOICE })
            }
          }
        }
      }
    },

    async created() {
      this.items = [...this.tender.criteria.price];
    },

    mounted() {
      this._updateTableRowsHeight();
    },

    updated() {
      this._updateTableRowsHeight();
    },

    watch: {
      'tender.criteria'() {
        this.items = [...this.tender.criteria.price];
      }
    },

    computed: {
      availableCriteria() {
        return this.criteria.map(e => ({
          id: e.id,
          name: e.name,
          disabled: !!_.find(this.items, { id: e.id })
        }));
      },

      tender() {
        return this.value;
      }
    },

    methods: {
      onAddCriterionClick() {
        this.editableItem = this.items.length;
        this.items.push({
          id: undefined,
          format: undefined,
          unit: undefined,
          maxValue: undefined,
          minValue: undefined,
          okei: undefined,
          editable: true,
          isNew: true,
          values: [],
          type: 'Price'
        });
        this.$v.$touch();
      },

      onSaveClick() {
        if (this.$v.$anyError) return;
        this.tender.criteria.price = this.items;
        this.items[this.editableItem].editable = false;
        this.editableItem = undefined;
        this.$emit('input', this.tender);
      },

      onCancelClick() {
        if (_.last(this.items).isNew) {
          this.items.pop();
        }
        else {
          this.items[this.editableItem].editable = false;
        }
        this.editableItem = undefined;
      },

      onEditClick(rowId) {
        this.editableItem = rowId;
        this.items[rowId].editable = true;
      },

      onCopyClick(rowId) {

      },

      onRemoveClick(rowId) {
        this.tender.criteria.price.splice(rowId, 1);
        this.$emit('input', this.tender);
      },

      onAddValuesClick(item) {
        if (!item.values) {
          item.values = [];
        }

        item.values.push({
          name: undefined,
          value: undefined
        });
      },

      _updateTableRowsHeight() {
        const dataRows = $(this.$el).find('.table-tab__container .table-tab__row-auto-height');
        const controlRows = $(this.$el).find('.table-tab__actions-block .table-tab__row-auto-height');

        if (dataRows.length !== controlRows.length) {
          console.error('amount of data and control rows should be the same');
          return;
        }

        for (let i = 0; i < dataRows.length; ++i) {
          const $d = $(dataRows[i]);
          const $c = $(controlRows[i]);

          const height = Math.max($d.height(), $c.height());

          $d.height(height);
          $c.height(height);
        }
      }
    }
  }
</script>

<style scoped>

</style>
